import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import SuggestionMenu from "features/ui/SuggestionMenu/SuggestionMenu";

import type { DirectiveComposerSuggestion } from "./DirectiveComposer.types";
import { selectDirectiveInvocation } from "./DirectiveComposerPlugins";

export const DIRECTIVE_COMPOSER_SUGGESTIONS_ID = "duck-directive-suggestions";

interface Props {
  activeIndex: number;
  directives: DirectiveComposerSuggestion[];
  onActiveIndexChange: (index: number) => void;
}

const DirectiveComposerSuggestionMenu = ({
  activeIndex,
  directives,
  onActiveIndexChange,
}: Props) => {
  const [editor] = useLexicalComposerContext();

  return (
    <SuggestionMenu
      activeIndex={activeIndex}
      className="mx-3 mb-2 max-h-48"
      getItemKey={({ name }) => name}
      getItemLabel={({ name }) => `/${name}`}
      getItemTestId={({ name }) => `duck-directive-suggestion-${name}`}
      id={DIRECTIVE_COMPOSER_SUGGESTIONS_ID}
      items={directives}
      testId={DIRECTIVE_COMPOSER_SUGGESTIONS_ID}
      onActiveIndexChange={onActiveIndexChange}
      onSelect={(directive) => selectDirectiveInvocation(editor, directive)}
    />
  );
};

export default DirectiveComposerSuggestionMenu;
